/**
 * @generated SignedSource<<f4000d6d0efa4ed1dd042687ba5c5488>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SetCanNotRestartIfPassedContentConfigInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type RestartIfPassedContentConfigEditor_SetCanNotRestartIfPassedContentConfigMutation$variables = {
  input: SetCanNotRestartIfPassedContentConfigInput;
};
export type RestartIfPassedContentConfigEditor_SetCanNotRestartIfPassedContentConfigMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly setCanNotRestartIfPassedContentConfig: {
        readonly contentNode: {
          readonly " $fragmentSpreads": FragmentRefs<"RestartIfPassedContentConfigEditor_TreeNodeFragment">;
        };
      } | null;
    };
  };
};
export type RestartIfPassedContentConfigEditor_SetCanNotRestartIfPassedContentConfigMutation = {
  response: RestartIfPassedContentConfigEditor_SetCanNotRestartIfPassedContentConfigMutation$data;
  variables: RestartIfPassedContentConfigEditor_SetCanNotRestartIfPassedContentConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RestartIfPassedContentConfigEditor_SetCanNotRestartIfPassedContentConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "SetCanNotRestartIfPassedContentConfigPayload",
                "kind": "LinkedField",
                "name": "setCanNotRestartIfPassedContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "RestartIfPassedContentConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RestartIfPassedContentConfigEditor_SetCanNotRestartIfPassedContentConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "SetCanNotRestartIfPassedContentConfigPayload",
                "kind": "LinkedField",
                "name": "setCanNotRestartIfPassedContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "restartIfPassedConfig",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ContentTypeDefinition",
                            "abstractKey": "__isContentTypeDefinition"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "64ae048fe3ff2b391ff42b5690e38f08",
    "id": null,
    "metadata": {},
    "name": "RestartIfPassedContentConfigEditor_SetCanNotRestartIfPassedContentConfigMutation",
    "operationKind": "mutation",
    "text": "mutation RestartIfPassedContentConfigEditor_SetCanNotRestartIfPassedContentConfigMutation(\n  $input: SetCanNotRestartIfPassedContentConfigInput!\n) {\n  Admin {\n    Tree {\n      setCanNotRestartIfPassedContentConfig(input: $input) {\n        contentNode {\n          ...RestartIfPassedContentConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment RestartIfPassedContentConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      restartIfPassedConfig {\n        __typename\n        configType\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5776211f202b87ad6a15ed4b7e903dba";

export default node;
